import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDroplet20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDroplet20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.75 12.77c0 2.608-2.122 4.73-4.75 4.73s-4.75-2.122-4.75-4.73c0-3 1.363-5.628 2.824-7.573A19 19 0 0 1 10 3.011c.534.52 1.23 1.261 1.926 2.186 1.461 1.945 2.824 4.574 2.824 7.572m1.5-.001C16.25 16.21 13.452 19 10 19s-6.25-2.79-6.25-6.23C3.75 5.866 10 1 10 1s6.25 4.867 6.25 11.77m-7.5 1.73a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDroplet20);
